import { fromJS } from 'immutable'

import {
  ACCOUNT_PHONE_VERIFY_GENERATE,
  ACCOUNT_PHONE_VERIFY_REGENERATE,
  ACCOUNT_PHONE_VERIFY_CONFIRM,
  ACCOUNT_PHONE_VERIFY_ERROR,
  ACCOUNT_PHONE_VERIFY_PROGRESS,
} from 'actions/verify-phone'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  verified: null,
  verificationSent: false,
  attempt: null,
  phone: null,
  contactId: null,
  attemptId: null,
  responseStatus: null,
})

export default function verifyPhoneReducer(state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_PHONE_VERIFY_GENERATE:
      return _generatePhoneVerify(state)
    case ACCOUNT_PHONE_VERIFY_REGENERATE:
      return _regeneratePhoneVerify(state)
    case ACCOUNT_PHONE_VERIFY_CONFIRM:
      return _confirmPhoneVerify(state)
    case ACCOUNT_PHONE_VERIFY_PROGRESS:
      return _updatePhoneVerifyProgress(state, action.payload)
    case ACCOUNT_PHONE_VERIFY_ERROR:
      return _errorPhoneVerify(state, action.payload)
    default:
      return state
  }
}

const _generatePhoneVerify = state => {
  return state.update('loading', () => true)
}

const _regeneratePhoneVerify = state => {
  return state.update('loading', () => true)
}

const _confirmPhoneVerify = state => {
  return state.update('loading', () => true)
}

const _errorPhoneVerify = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}

const _updatePhoneVerifyProgress = (state, payload) => {
  return state
    .set('verificationSent', true)
    .merge(payload)
    .set('error', () => false)
    .set('errorData', () => null)
    .update('loading', () => false)
}
